export default {
    props: {
        excelFileName: {
            type: String,
            kComposite: 'excel.fileName'
        }, 
        excelFilterable: {
            type: Boolean,
            kComposite: 'excel.filterable'
        }, 
        excelForceProxy: {
            type: Boolean,
            kComposite: 'excel.forceProxy'
        }, 
        excelProxyURL: {
            type: String,
            kComposite: 'excel.proxyURL'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/Excel.js